// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6597525","239":"41cd4c77","453":"2fedd66f","732":"d0e24685"}[chunkId] + ".chunk.js";
};